var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrevYearQues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58333 0.875H24.5417C25.2268 0.875 25.8839 1.14717 26.3684 1.63164C26.8528 2.11611 27.125 2.77319 27.125 3.45833V8.625H24.5417V3.45833H2.58333V21.5417H24.5417V16.375H27.125V21.5417C27.125 22.2268 26.8528 22.8839 26.3684 23.3684C25.8839 23.8528 25.2268 24.125 24.5417 24.125H2.58333C1.89819 24.125 1.24111 23.8528 0.756641 23.3684C0.272172 22.8839 0 22.2268 0 21.5417V3.45833C0 2.77319 0.272172 2.11611 0.756641 1.63164C1.24111 1.14717 1.89819 0.875 2.58333 0.875ZM21.9583 16.375V13.7917H31V11.2083H21.9583V8.625L16.7917 12.5L21.9583 16.375ZM5.16667 13.7917H14.2083V11.2083H5.16667V13.7917ZM5.16667 8.625H14.2083V6.04167H5.16667V8.625ZM5.16667 18.9583H10.3333V16.375H5.16667V18.9583Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevYearQues);
export default __webpack_public_path__ + "static/media/PrevYearQues.78696da7db3e2ef210c3c007c3201f7d.svg";
export { ForwardRef as ReactComponent };